import { RadioSticky } from "../radio/radio-sticky";

export class MediaAudio {
    // @url https://developer.jwplayer.com/jw-player/docs/javascript-api-reference
    // @url https://developer.jwplayer.com/jw-player/docs/developer-guide/customization/configuration-reference
    hostUrl = '//content.jwplatform.com/libraries/PmZ5wBMW.js';

    defaultOptions = {
        stretching: 'uniform',
        abouttext: 'Ondamadrid.es',
        aboutlink: 'http://www.ondamadrid.es',
        ga: {
            label: 'title'
        }
    };

    controlTPL = [
        '<div class="media-control">',
        '<button class="media-control__play-button" title="Reproducir">Reproducir</button>',
        '<button class="media-control__volume-button" title="Modificar volumen">Volumen</button>',
        '<div class="media-control__volume-range">',
        '<input type="range" min="0" max="1" step="0.1">',
        '</div>',
        '<div class="media-control__progress" title="Duración">',
        '<input type="text" value="00:00:00" readonly>',
        '</div>',
        '<div class="media-control__bar" title="0% de progreso">',
        '<span>0% de progreso</span>',
        '</div>',
        '</div>'
    ].join('');

    d = $.Deferred();
    instances = [];

    // staff
    audios;
    controls;

    constructor() {
        this.init();
    }

    init() {
        this.audios = $('.media-audio');

        if (!this.audios.length) {
            return;
        }

        if (this.d.state() !== 'resolved') {
            this.load();
        }

        this.d.done(() => {
            this.controls = $(this.controlTPL).appendTo(this.audios).addClass('media-control--loading');

            this.audios.each((index, element) => {
                const media = $(element).find('audio');

                const player = window.jwplayer(media.get(0)).setup($.extend({
                    file: media.find('source').prop('src')
                }, this.defaultOptions));

                this.instances.push(player);

                player
                    .on('ready', () => {
                        this.controls.eq(index).addClass('media-control--ready');
                    })
                    .on('setupError', (e) => {
                        console.debug('Player error', e);
                        this.controls.eq(index).addClass('media-control--error');
                    })
                    .on('bufferChange', (e) => {
                        if (!this.controls.eq(index).is('.media-control--loaded')) {
                            console.debug('onBufferChange ', e);

                            this.controls.eq(index)
                                .removeClass('media-control--loading')
                                .addClass('media-control--loaded')
                                // states
                                .find('.media-control__volume-range input').val(player.getVolume() / 100)
                                .end()
                                .find('.media-control__progress input').val(this.formatTime(player.getDuration()));
                        }
                    })
                    .on('error', (e) => {
                        console.debug('Player error', e);
                        this.controls.eq(index).addClass('media-control--error');
                    })
                    .on('seek', () => {
                        this.setProgress(player);
                    })
                    .on('time', () => {
                        this.setProgress(player);
                    });
            });

            this.bindEvents();
        });
    }

    load() {
        if (window.jwplayer) {
            this.d.resolve();
            return;
        }

        $.getScript(this.hostUrl, () => this.onLoad()).fail(() => this.onLoadError());
    }

    onLoad() {
        console.debug('jwplayer successfully loaded! ', window.jwplayer.version);
        this.d.resolve();
    }

    onLoadError() {
        console.debug("jwplayer lib couldn't be loaded!");
        this.d.reject();
        this.d = $.Deferred();
    }

    bindEvents() {
        this.controls
            .on('click', '.media-control__play-button', (e) => this.onPlayButton(e))
            .on('click', '.media-control__volume-button', (e) => this.onVolumeButton(e))
            .on('change', '.media-control__volume-range input', (e) =>this.onVolumeRange(e))
            .on('click', '.media-control__bar', (e) => this.onBar(e));
    }

    onPlayButton(e) {
        if (!$(e.delegateTarget).is('.media-control--ready')) {
            return;
        }

        const index = this.controls.index(e.delegateTarget);
        const player = this.instances[index];
        const audio = this.audios[index];
        const playButton = $(audio).find('.media-control__play-button');

        playButton.is('.media-control__play-button--active') ? this.pause(playButton, player) : this.play(playButton, player);
    }

    play(button, player) {
        button
            .addClass('media-control__play-button--active')
            .prop('title', 'Pausar')
            .text('Pausar');

        player.play();

        const radioInset = button.closest(".radio-inset");
        if (!radioInset.length) {
            return;
        }

        const radioSubbody = radioInset.find('.radio-inset__subbody');
        if (radioSubbody.length > 0) {
            new RadioSticky(radioSubbody.first());
        }
    }

    pause(button, player) {
        button
            .removeClass('media-control__play-button--active')
            .prop('title', 'Reproducir')
            .text('Reproducir');

        player.pause();
    }

    onVolumeButton(e) {
        e.preventDefault();

        $(e.delegateTarget).find('.media-control__volume-range').toggleClass('media-control__volume-range--active');
    }

    onVolumeRange(e) {
        e.preventDefault();

        const volumeRange = $('.media-control__volume-range input');
        const index = this.controls.index(e.delegateTarget);
        const volume = volumeRange.val() * 100;

        volumeRange.closest('.media-control__volume-range').removeClass('media-control__volume-range--active');

        if (volume === 0) {
            $(e.delegateTarget).find('.media-control__volume-button')
                .addClass('media-control__volume-button--muted')
                .text('Mute');
        } else {
            $(e.delegateTarget).find('.media-control__volume-button')
                .removeClass('media-control__volume-button--muted')
                .text('Volumen');
        }

        this.instances[index].setVolume(volume);
    }

    onBar(e) {
        if (!$(e.delegateTarget).is('.media-control--ready')) {
            return;
        }

        const index = this.controls.index(e.delegateTarget);
        const player = this.instances[index];
        const ratio = e.offsetX / this.controls.eq(index).find('.media-control__bar').outerWidth();

        player.seek(ratio * player.getDuration());
        this.controls.eq(index).find('.media-control__progress input').val(this.formatTime(player.getPosition()));
    }

    // auxiliary
    setProgress(player) {
        const index = this.audios.index(player);
        const progressPercentage = (player.getPosition() / player.getDuration()) * 100;
        const progressText = Math.ceil(progressPercentage) + '% de progreso';

        this.controls.eq(index)
            .find('.media-control__progress input').val(this.formatTime(player.getPosition()))
            .end()
            .find('.media-control__bar').prop('title', progressText)
            .find('span')
            .css('width', progressPercentage.toFixed(4) + '%')
            .text(progressText);
    }

    formatTime(n) {
        const date = new Date(null);

        date.setSeconds(n);

        return date.toISOString().substr(11, 8);
    }
}
